import { useCallback, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { listDemos } from "../api/demosApi";
import { computePendingDemos } from "../utils/pendingDemos";

// Demos pendientes de seguimiento del usuario actual (closer). Se apoya en
// listDemos() (ya scoped por el backend) y filtra en cliente por closer===yo.
export default function usePendingDemos() {
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      let me = null;
      try { me = jwtDecode(localStorage.getItem("token"))?.user_id || null; } catch (_) {}
      if (!me) { setPending([]); return; }
      const demos = await listDemos();
      setPending(computePendingDemos(demos, { userId: me, nowMs: Date.now() }));
    } catch (_) {
      setPending([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return { pending, count: pending.length, loading, reload };
}
